import { LogOut } from "lucide-react";
import { ChatStore } from "@/stores/ChatStore";
import { Providers } from "@microsoft/mgt-element";
import { useTranslation } from "react-i18next";

export default function SignOutButton() {
  const { t } = useTranslation();
  const setIsRunning = ChatStore(state => state.setIsRunning);

  const handleSignOut = () => {
    setIsRunning(false);
    // Clear local session without logging out from Microsoft
    if (Providers.globalProvider) {
      sessionStorage.clear();
      localStorage.clear();
      // Force a page reload to clear any remaining state
      window.location.reload();
    }
  };

  return (
    <div className="p-2 rounded-md flex cursor-pointer gap-3 hover:bg-muted" onClick={handleSignOut} title={t('common.signOut')}>      <LogOut className="h-6 w-6" strokeWidth={1} />
      <div className={"whitespace-nowrap"}>{t('common.signOut')}</div>
    </div>
  );
}
